module.exports = __webpack_public_path__ + "img/shot_bigtx112802.2d5156ce.png";